/* cvp-pp.js: the product page v3 configurator (sections/cvp-pp-main.liquid). One IIFE, no
   dependencies. Reads the JSON the section renders, keeps one state (finish, shape, size, units)
   and re-renders every dependent piece on change: stage, thumbnails, prices, sizes, trust facts,
   the scale card, the sticky bar, the URL. Add to cart posts to the cart API and opens the cart
   page (cart type is "page"); a failed request falls back to the ordinary form submit. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cvp-pp]');
  if (!root) return;
  var dataEl = root.querySelector('[data-pp-data]');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollMode = reduce ? 'auto' : 'smooth';

  /* ── helpers ── */
  function dims(z) {
    var p = String(z || '').toLowerCase().split('x');
    return { w: parseInt(p[0], 10) || 0, h: parseInt(p[1], 10) || 0 };
  }
  function shapeLabel(s) { return s === 'Potrait' ? 'Portrait' : s; }
  function sameShape(a, b) { return shapeLabel(a) === shapeLabel(b); }
  function cm(n) { return Math.round(n * 2.54); }
  function sizeIn(z) { var d = dims(z); return d.w + ' × ' + d.h + ' in'; }
  function sizeCm(z) { var d = dims(z); return cm(d.w) + ' × ' + cm(d.h) + ' cm'; }
  function sizeText(z, units) { return units === 'cm' ? sizeCm(z) : sizeIn(z); }
  function area(z) { var d = dims(z); return d.w * d.h; }
  function byArea(a, b) { return area(a.z) - area(b.z); }
  function variantsFor(f, s) {
    return D.variants.filter(function (v) { return v.f === f && sameShape(v.s, s); }).sort(byArea);
  }
  function find(f, s, z) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (v.f === f && sameShape(v.s, s) && v.z === z) return v;
    }
    return null;
  }
  function firstShapeFor(f) {
    for (var i = 0; i < D.shapes.length; i++) if (variantsFor(f, D.shapes[i]).length) return D.shapes[i];
    return null;
  }
  function firstFinishFor(s) {
    for (var i = 0; i < D.finishes.length; i++) if (variantsFor(D.finishes[i], s).length) return D.finishes[i];
    return null;
  }
  function shapesFor(f) {
    return D.shapes.filter(function (s) { return variantsFor(f, s).length > 0; });
  }
  function closestSize(list, z) {
    if (!list.length) return null;
    var want = dims(z), best = list[0], bestD = Infinity;
    list.forEach(function (v) {
      if (v.z === z) { best = v; bestD = -1; return; }
      if (bestD === -1) return;
      var d = dims(v.z), diff = Math.abs(d.w - want.w) + Math.abs(d.h - want.h);
      if (diff < bestD) { bestD = diff; best = v; }
    });
    return best;
  }
  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function setText(sel, txt) { var el = $(sel); if (el && el.textContent !== txt) el.textContent = txt; }

  /* ── state ── */
  var state = { f: null, s: null, z: null, units: 'in' };
  (function init() {
    var cur = null;
    for (var i = 0; i < D.variants.length; i++) if (D.variants[i].id === D.cur) cur = D.variants[i];
    cur = cur || D.variants[0];
    if (!cur) return;
    state.f = cur.f; state.s = cur.s; state.z = cur.z;
    try { var u = localStorage.getItem('cvp-pp-units'); if (u === 'cm' || u === 'in') state.units = u; } catch (e) {}
  })();
  if (!state.f && !state.z) return;

  var lastShape = state.s, lastHero = null;

  /* ── stage ── */
  var track = $('[data-pp-track]');
  var rail = $('[data-pp-rail]');
  var heroFig = $('[data-pp-slide="product"]');
  var heroImg = $('[data-pp-hero]');
  lastHero = heroImg ? heroImg.getAttribute('src') : null;

  function slides() { return $$('.cvp-pp__slide', track); }
  function currentIndex() {
    if (!track) return 0;
    var w = track.clientWidth || 1;
    return Math.max(0, Math.min(slides().length - 1, Math.round(track.scrollLeft / w)));
  }
  function goTo(i) {
    if (!track) return;
    var n = slides().length;
    i = ((i % n) + n) % n;
    track.scrollTo({ left: i * track.clientWidth, behavior: scrollMode });
  }
  function markCurrent() {
    var i = currentIndex();
    $$('[data-pp-thumb]').forEach(function (t) {
      var on = parseInt(t.getAttribute('data-pp-thumb'), 10) === i;
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on && rail) {
        /* scroll the thumbnail row sideways only; scrollIntoView would also move the page */
        var r = t.getBoundingClientRect(), rr = rail.getBoundingClientRect();
        if (r.left < rr.left || r.right > rr.right) {
          rail.scrollBy({ left: r.left - rr.left - (rr.width - r.width) / 2, behavior: scrollMode });
        }
      }
    });
    $$('[data-pp-view]').forEach(function (b) {
      var on = b.getAttribute('data-pp-view') === (i === 0 ? 'product' : 'room');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function buildDots() { markCurrent(); }
  function roomsFor(s) {
    return D.rooms.filter(function (r) { return !r.s || sameShape(r.s, s); });
  }
  function rebuildRooms(s) {
    if (!track) return;
    $$('[data-pp-slide="room"]', track).forEach(function (el) { el.parentNode.removeChild(el); });
    if (rail) $$('[data-pp-thumb]', rail).forEach(function (t, k) { if (k > 0) t.parentNode.removeChild(t); });
    roomsFor(s).forEach(function (r, k) {
      var fig = document.createElement('figure');
      fig.className = 'cvp-pp__slide';
      fig.setAttribute('data-pp-slide', 'room');
      var im = document.createElement('img');
      im.src = r.img; im.width = 1200; im.height = 1200; im.loading = 'lazy';
      im.alt = D.title + ' in a room, ' + shapeLabel(s).toLowerCase();
      fig.appendChild(im);
      track.appendChild(fig);
      if (rail) {
        var b = document.createElement('button');
        b.className = 'cvp-pp__thumb'; b.type = 'button';
        b.setAttribute('data-pp-thumb', String(k + 1));
        b.setAttribute('aria-label', 'Room view ' + (k + 1));
        b.setAttribute('aria-current', 'false');
        var ti = document.createElement('img');
        ti.src = r.th; ti.width = 72; ti.height = 72; ti.alt = ''; ti.loading = 'lazy';
        b.appendChild(ti);
        rail.appendChild(b);
      }
    });
    var rc = $('[data-pp-room-count]'), rb = $('[data-pp-view="room"]'), nRooms = roomsFor(s).length;
    if (rc) rc.textContent = String(nRooms);
    if (rb) rb.hidden = nRooms === 0;
    buildDots();
  }
  function setHero(v) {
    if (!heroImg || !v.img || v.img === lastHero) return;
    lastHero = v.img;
    var t0 = $('[data-pp-thumb="0"] img');
    if (t0 && v.th) t0.src = v.th;
    var bi = $('[data-pp-bar-img]');
    if (bi && v.th) bi.src = v.th;
    heroImg.removeAttribute('srcset');
    heroImg.alt = D.title + ', ' + v.f.toLowerCase() + ', ' + shapeLabel(v.s).toLowerCase();
    if (reduce || !heroFig) { heroImg.src = v.img; return; }
    /* fade only while the new file is still arriving; a cached one paints at once */
    heroFig.setAttribute('data-fading', '');
    heroImg.src = v.img;
    var clear = function () { heroFig.removeAttribute('data-fading'); };
    if (heroImg.complete && heroImg.naturalWidth) { clear(); return; }
    heroImg.addEventListener('load', clear, { once: true });
    heroImg.addEventListener('error', clear, { once: true });
  }
  if (track) {
    var scrollT;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollT); scrollT = setTimeout(markCurrent, 80);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
    });
    window.addEventListener('resize', function () { track.scrollLeft = currentIndex() * track.clientWidth; });
  }
  root.addEventListener('click', function (e) {
    var vb = e.target.closest('[data-pp-view]');
    if (vb) goTo(vb.getAttribute('data-pp-view') === 'room' ? 1 : 0);
  });
  /* hover zoom removed on the owner's instruction (2026-09-28); the full-size view stays on click and the zoom button */
  if (track) track.addEventListener('click', function (e) {
    if (e.target.closest('.cvp-pp__slide')) openLightbox();
  });
  if (rail) rail.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pp-thumb]');
    if (t) goTo(parseInt(t.getAttribute('data-pp-thumb'), 10));
  });
  var prev = $('[data-pp-prev]'), next = $('[data-pp-next]');
  if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
  if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
  buildDots();

  /* lightbox */
  var lb = $('[data-pp-lb]'), lbImg = $('[data-pp-lb-img]'), lbWrap = $('[data-pp-lb-wrap]');
  function openLightbox() {
    if (!lb || !lbImg || typeof lb.showModal !== 'function') return;
    var img = slides()[currentIndex()];
    img = img && img.querySelector('img');
    if (!img) return;
    lbImg.src = img.currentSrc || img.src;
    lbImg.src = lbImg.src.replace(/width=\d+/, 'width=2000');
    lbImg.alt = img.alt;
    lb.removeAttribute('data-zoom');
    lb.showModal();
  }
  var zoomBtn = $('[data-pp-zoom]');
  if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);
  if (lb) {
    var lbClose = $('[data-pp-lb-close]');
    if (lbClose) lbClose.addEventListener('click', function () { lb.close(); });
    if (lbWrap) lbWrap.addEventListener('click', function (e) {
      if (e.target === lbImg) { if (lb.hasAttribute('data-zoom')) lb.removeAttribute('data-zoom'); else lb.setAttribute('data-zoom', ''); }
      else lb.close();
    });
  }

  /* ── the scale card ── */
  var svg = $('[data-pp-scale-svg]');
  function drawScale(w, h, v) {
    if (!svg || !w || !h) return;
    var sofa = D.sofa || 84;
    /* a whole sofa (legs 4 in, seat 18 in, arms 26 in, back 34 in) on the floor, the artwork hung
       8 inches above its back. One px-per-inch for every size of the chosen shape, taken from the
       largest one, so hovering sizes changes the artwork and never the sofa */
    var floor = 180, top = 22, backIn = 34, gapIn = 8;
    var list = variantsFor(state.f, state.s), maxW = w, maxH = h;
    list.forEach(function (x) { var d = dims(x.z); if (d.w > maxW) maxW = d.w; if (d.h > maxH) maxH = d.h; });
    var s = Math.min(1.6, (floor - top) / (backIn + gapIn + maxH), 380 / maxW, 380 / sofa);
    var sofaW = sofa * s;
    var x0 = (400 - sofaW) / 2;
    var r = Math.max(2, 2 * s);
    var y = function (inches) { return floor - inches * s; };
    var sofaG = $('[data-pp-sofa]', svg);
    sofaG.innerHTML =
      '<rect x="' + (x0 + 7 * s) + '" y="' + y(backIn) + '" width="' + (sofaW - 14 * s) + '" height="' + (16 * s + r) + '" rx="' + r + '"/>' +
      '<rect x="' + x0 + '" y="' + y(18) + '" width="' + sofaW + '" height="' + (14 * s) + '" rx="' + r + '"/>' +
      '<line x1="' + (x0 + 8 * s) + '" y1="' + y(12) + '" x2="' + (x0 + sofaW - 8 * s) + '" y2="' + y(12) + '"/>' +
      '<line x1="' + (400 / 2) + '" y1="' + y(18) + '" x2="' + (400 / 2) + '" y2="' + y(12) + '"/>' +
      '<line x1="' + (400 / 2) + '" y1="' + (y(backIn) + 3 * s) + '" x2="' + (400 / 2) + '" y2="' + y(18) + '"/>' +
      '<rect x="' + x0 + '" y="' + y(26) + '" width="' + (8 * s) + '" height="' + (22 * s) + '" rx="' + r + '"/>' +
      '<rect x="' + (x0 + sofaW - 8 * s) + '" y="' + y(26) + '" width="' + (8 * s) + '" height="' + (22 * s) + '" rx="' + r + '"/>' +
      '<rect x="' + (x0 + 5 * s) + '" y="' + y(4) + '" width="' + (2.5 * s) + '" height="' + (4 * s) + '"/>' +
      '<rect x="' + (x0 + sofaW - 7.5 * s) + '" y="' + y(4) + '" width="' + (2.5 * s) + '" height="' + (4 * s) + '"/>';
    var yb = y(backIn);
    var aw = w * s, ah = h * s;
    var ax = (400 - aw) / 2, ay = yb - gapIn * s - ah;
    if (ay < top) ay = top;
    var artG = $('[data-pp-art]', svg);
    var src = v && (v.sm || v.th) ? (v.sm || v.th) : '';
    var clipId = 'cvp-pp-clip';
    artG.innerHTML =
      '<defs><clipPath id="' + clipId + '"><rect x="' + ax + '" y="' + ay + '" width="' + aw + '" height="' + ah + '"/></clipPath></defs>' +
      '<rect x="' + (ax + 2) + '" y="' + (ay + 3) + '" width="' + aw + '" height="' + ah + '" fill="var(--cvp-line-light)"/>' +
      '<rect x="' + ax + '" y="' + ay + '" width="' + aw + '" height="' + ah + '" fill="var(--cvp-paper-sunken)"/>' +
      (src ? '<image href="' + src + '" x="' + (ax - aw * 0.02) + '" y="' + (ay - ah * 0.02) + '" width="' + (aw * 1.04) + '" height="' + (ah * 1.04) + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + clipId + ')"/>' : '') +
      '<rect x="' + ax + '" y="' + ay + '" width="' + aw + '" height="' + ah + '" fill="none" stroke="var(--cvp-ink)" stroke-width=".75"/>';
    var dimG = $('[data-pp-dim]', svg);
    var dy = Math.max(15, ay - 6);
    dimG.innerHTML = '<line x1="' + ax + '" y1="' + dy + '" x2="' + (ax + aw) + '" y2="' + dy + '"/>' +
      '<line x1="' + ax + '" y1="' + (dy - 3) + '" x2="' + ax + '" y2="' + (dy + 3) + '"/>' +
      '<line x1="' + (ax + aw) + '" y1="' + (dy - 3) + '" x2="' + (ax + aw) + '" y2="' + (dy + 3) + '"/>';
    var t = $('[data-pp-dim-txt]', svg);
    if (t) {
      t.textContent = state.units === 'cm' ? cm(w) + ' × ' + cm(h) + ' cm' : w + ' × ' + h + ' in';
      t.setAttribute('y', String(dy - 5));
    }
  }
  function drawSelected() {
    var v = find(state.f, state.s, state.z);
    var d = dims(state.z);
    drawScale(d.w, d.h, v);
    setText('[data-pp-scale-size]', sizeText(state.z, state.units));
  }

  /* ── sizes ── */
  var sizesEl = $('[data-pp-sizes]');
  function renderSizes() {
    if (!sizesEl) return;
    var list = variantsFor(state.f, state.s);
    var html = '';
    list.forEach(function (v) {
      var d = dims(v.z);
      html += '<label class="cvp-pp__opt" data-pp-size-opt="' + v.z + '" data-w="' + d.w + '" data-h="' + d.h + '">' +
        '<input type="radio" name="cvp-size" value="' + v.z + '"' + (v.z === state.z ? ' checked' : '') + ' data-pp-size>' +
        '<span class="cvp-pp__size"><b>' + (state.units === 'cm' ? sizeCm(v.z) : sizeIn(v.z)) + '</b>' +
        '<small>' + (state.units === 'cm' ? sizeIn(v.z) : sizeCm(v.z)) + '</small>' +
        (v.a ? '' : '<em>Sold out</em>') + '</span></label>';
    });
    sizesEl.innerHTML = html;
  }

  /* ── render everything from state ── */
  function render() {
    var list = variantsFor(state.f, state.s);
    if (!list.length) return;
    var v = find(state.f, state.s, state.z);
    if (!v) { v = closestSize(list, state.z); state.z = v.z; }

    var idEl = $('[data-pp-id]');
    if (idEl) idEl.value = v.id;
    setText('[data-pp-price]', v.pf);
    setText('[data-pp-add-price]', v.pf);
    setText('[data-pp-bar-price]', v.pf);
    setText('[data-pp-finish-name]', v.f);
    setText('[data-pp-shape-name]', shapeLabel(v.s));
    setText('[data-pp-size-name]', sizeText(v.z, state.units));
    var sel = v.f + ', ' + shapeLabel(v.s).toLowerCase() + ', ' + sizeIn(v.z);
    setText('[data-pp-tag]', sizeText(v.z, state.units) + ' \u00b7 ' + v.f);
    setText('[data-pp-bar-sel]', sel);
    setText('[data-pp-meta-finish]', v.f);
    setText('[data-pp-meta-shape]', shapeLabel(v.s));
    setText('[data-pp-meta-size]', sizeIn(v.z) + ' (' + sizeCm(v.z) + ')');
    if (v.a) root.removeAttribute('data-unavailable'); else root.setAttribute('data-unavailable', '');
    var addBtn = $('[data-pp-add]');
    if (addBtn) addBtn.disabled = !v.a;

    /* finish tiles */
    $$('[data-pp-finish-opt]').forEach(function (opt) {
      var f = opt.getAttribute('data-pp-finish-opt');
      var here = variantsFor(f, state.s);
      var from = opt.querySelector('[data-pp-from]');
      var input = opt.querySelector('input');
      if (input) input.checked = f === state.f;
      if (here.length) {
        opt.removeAttribute('data-off');
        if (from) from.textContent = '';
      } else {
        opt.setAttribute('data-off', '');
        if (from) from.textContent = shapesFor(f).map(function (s) { return shapeLabel(s).toLowerCase(); }).join(', ') + ' only';
      }
    });
    /* shape tiles */
    $$('[data-pp-shape-opt]').forEach(function (opt) {
      var s = opt.getAttribute('data-pp-shape-opt');
      var here = variantsFor(state.f, s);
      var note = opt.querySelector('[data-pp-shape-note]');
      var input = opt.querySelector('input');
      if (input) input.checked = sameShape(s, state.s);
      if (here.length) {
        opt.removeAttribute('data-off');
        if (note) note.textContent = here.length + ' size' + (here.length === 1 ? '' : 's');
      } else {
        opt.setAttribute('data-off', '');
        if (note) note.textContent = 'other finishes';
      }
    });
    renderSizes();

    /* trust and material copy per finish */
    var canvas = (D.canvasFinishes || []).indexOf(v.f) > -1;
    setText('[data-pp-trust-material]', canvas ? 'Museum-quality canvas, archival inks' : 'Archival inks that resist fading');
    setText('[data-pp-trust-hang]', canvas ? 'Solid wooden inner frame, ready to hang' : (v.f === 'Framed Print' ? 'Ready to hang in its frame' : 'Unframed, ready to frame or mount'));
    setText('[data-pp-material-copy]', canvas
      ? 'Printed to order on museum-quality canvas with archival inks that resist fading, stretched over a solid wooden inner frame. It arrives ready to hang.'
      : (v.f === 'Framed Print'
        ? 'Printed to order with archival inks that resist fading and set in its frame. It arrives ready to hang.'
        : 'Printed to order with archival inks that resist fading. It arrives unframed, ready to frame or mount.'));

    /* stage */
    setHero(v);
    if (!sameShape(lastShape, v.s)) { rebuildRooms(v.s); lastShape = v.s; goTo(0); }
    drawSelected();

    /* url */
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('variant') !== String(v.id)) {
        u.searchParams.set('variant', String(v.id));
        history.replaceState(null, '', u.toString());
      }
    } catch (e) {}
  }

  /* ── events ── */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-pp-finish]')) {
      state.f = t.value;
      if (!variantsFor(state.f, state.s).length) state.s = firstShapeFor(state.f) || state.s;
      render();
    } else if (t.matches('[data-pp-shape]')) {
      state.s = t.value;
      if (!variantsFor(state.f, state.s).length) state.f = firstFinishFor(state.s) || state.f;
      render();
    } else if (t.matches('[data-pp-size]')) {
      state.z = t.value;
      render();
    }
  });
  root.addEventListener('click', function (e) {
    var u = e.target.closest('[data-pp-unit]');
    if (u) {
      state.units = u.getAttribute('data-pp-unit') === 'cm' ? 'cm' : 'in';
      try { localStorage.setItem('cvp-pp-units', state.units); } catch (err) {}
      applyUnits();
    }
  });
  function applyUnits() {
    root.setAttribute('data-units', state.units);
    $$('[data-pp-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pp-unit') === state.units ? 'true' : 'false'); });
    setText('[data-pp-size-name]', sizeText(state.z, state.units));
    var tv = find(state.f, state.s, state.z);
    if (tv) setText('[data-pp-tag]', sizeText(tv.z, state.units) + ' \u00b7 ' + tv.f);
    renderSizes();
    drawSelected();
  }
  /* hover or focus a size: preview it on the wall */
  function previewFrom(el) {
    var opt = el && el.closest && el.closest('[data-pp-size-opt]');
    if (!opt) return false;
    var v = find(state.f, state.s, opt.getAttribute('data-pp-size-opt'));
    drawScale(parseInt(opt.getAttribute('data-w'), 10), parseInt(opt.getAttribute('data-h'), 10), v);
    setText('[data-pp-scale-size]', sizeText(opt.getAttribute('data-pp-size-opt'), state.units));
    return true;
  }
  if (sizesEl) {
    sizesEl.addEventListener('mouseover', function (e) { previewFrom(e.target); });
    sizesEl.addEventListener('mouseleave', drawSelected);
    sizesEl.addEventListener('focusin', function (e) { previewFrom(e.target); });
    sizesEl.addEventListener('focusout', function (e) { if (!sizesEl.contains(e.relatedTarget)) drawSelected(); });
  }

  /* below-the-fold sections ask for a finish */
  document.addEventListener('cvp:pp:select', function (e) {
    var d = e.detail || {};
    if (d.finish && D.finishes.indexOf(d.finish) > -1) {
      state.f = d.finish;
      if (!variantsFor(state.f, state.s).length) state.s = firstShapeFor(state.f) || state.s;
    }
    if (d.shape && D.shapes.indexOf(d.shape) > -1) {
      state.s = d.shape;
      if (!variantsFor(state.f, state.s).length) state.f = firstFinishFor(state.s) || state.f;
    }
    render();
    var step = $('[data-pp-step="finish"]') || root;
    step.scrollIntoView({ behavior: scrollMode, block: 'center' });
  });

  /* ── add to cart ── */
  var form = document.getElementById('cvp-pp-form');
  var adding = false;
  function addToCart(btn) {
    if (adding) return;
    var v = find(state.f, state.s, state.z);
    if (!v || !v.a) return;
    adding = true;
    var labels = $$('[data-pp-add-label], [data-pp-bar-add] > span:first-child');
    labels.forEach(function (l) { l.textContent = 'Adding'; });
    if (btn) btn.disabled = true;
    var body = { items: [{ id: v.id, quantity: 1 }] };
    var done = function (ok) {
      if (ok) {
        labels.forEach(function (l) { l.textContent = 'Added'; });
        window.location.assign(D.cart);
      } else if (form) {
        form.submit();
      } else {
        adding = false;
        labels.forEach(function (l) { l.textContent = 'Add to cart'; });
        if (btn) btn.disabled = false;
      }
    };
    if (!window.fetch) { done(false); return; }
    fetch(D.addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { done(r.ok); }).catch(function () { done(false); });
  }
  if (form) form.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && !sub.matches('[data-pp-add]')) return;
    e.preventDefault();
    addToCart($('[data-pp-add]'));
  });
  var barAdd = $('[data-pp-bar-add]');
  if (barAdd) barAdd.addEventListener('click', function () { addToCart(barAdd); });

  /* ── sticky bar ── */
  var bar = $('[data-pp-bar]'), mainAdd = $('[data-pp-add]');
  if (bar && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var on = !en.isIntersecting;
        if (on) { bar.setAttribute('data-on', ''); bar.setAttribute('aria-hidden', 'false'); }
        else { bar.removeAttribute('data-on'); bar.setAttribute('aria-hidden', 'true'); }
      });
    }, { threshold: 0, rootMargin: '-84px 0px 0px 0px' }).observe(mainAdd);
  }

  /* ── delivery window, refreshed on the visitor's clock ── */
  (function eta() {
    var el = $('[data-pp-eta]');
    if (!el || !D.eta) return;
    // business days (owner 2026-10-04): count Monday to Friday only, as the Liquid render does
    function addBiz(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var a = addBiz(D.eta[0]), b = addBiz(D.eta[1]);
    el.textContent = fmtDate(a) + ' to ' + fmtDate(b);
  })();

  if (window.matchMedia && window.matchMedia('(hover: none)').matches) setText('[data-pp-scale-hint]', 'Tap a size to compare');
  applyUnits();
  render();
  markCurrent();
})();
